export const environment = {
    production: true,
    apiBaseUrl: 'https://hspm-api-staging.hs-plus.com',
    googleLoginRoute: 'https://hspm-api-staging.hs-plus.com/auth/google',
    s3BaseUrl: 'https://media-staging.hs-plus.com'
};
